import {
  AuthClient,
  AuthForgotPasswordRequest,
  AuthLoginRequest,
  AuthLogoutRequest,
  AuthResetPasswordRequest,
} from "../web-api-client";
import { getApiBaseUrl } from "../config/runtimeConfig";

const apiBaseUrl = getApiBaseUrl();

const http = {
  fetch(url: RequestInfo, init?: RequestInit): Promise<Response> {
    return fetch(url, {
      ...init,
      credentials: "include",
    });
  },
};

const client = new AuthClient(apiBaseUrl, http);

export const authClient = {
  me: () => client.me2(),
  login: (request: AuthLoginRequest) => client.login(request),
  logout: (request: AuthLogoutRequest) => client.logout(request),
  forgotPassword: (request: AuthForgotPasswordRequest) =>
    client.forgotPassword(request),
  resetPassword: (request: AuthResetPasswordRequest) =>
    client.resetPassword(request),
};
